import { LOCALES, LOCALE_LABEL, LOCALE_NAME } from '@/i18n';
import { useSettings } from '@/store/settings';

export function LangSwitch({ long = false }: { long?: boolean }) {
  const lang = useSettings((s) => s.lang);
  const setLang = useSettings((s) => s.setLang);
  return (
    <span className="inline-flex gap-[3px] rounded-full border border-line-strong p-[3px]" role="group" aria-label="Language">
      {LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          aria-pressed={lang === l}
          onClick={() => setLang(l)}
          className="h-[34px] rounded-full px-4 text-[12px] font-bold uppercase tracking-[0.12em] text-fg-muted aria-pressed:bg-accent aria-pressed:text-bg"
        >
          {long ? LOCALE_NAME[l] : LOCALE_LABEL[l]}
        </button>
      ))}
    </span>
  );
}
